module.exports = __webpack_public_path__ + "static/media/privacy-lock.c6d16d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/privacy-lock.png
// module id = 1184
// module chunks = 0